<template>
  <div ref="fixedgt" class="right-fixedgt" style="right: 18px;">
    <div class="fixedgt">
      <div class="fz_fan">
        <a
          href="http://wpa.qq.com/msgrd?v=3&uin=956051261&site=qq&menu=yes"
          target="_blank"
        >
          <div class="fz_li">
            <img
              :src="require('@/assets/icon/consulting.png')"
              alt=""
              class="icon"
            />
            <div class="text">在线咨询</div>
          </div>
        </a>
      </div>
      <div class="fz_fan">
        <div class="fz_li">
          <img
            :src="require('@/assets/icon/telephone.png')"
            alt=""
            class="icon"
          />
          <div class="text">联系我们</div>
        </div>
        <div class="hover">
          <div class="link">
            <div class="fz_t">售前咨询</div>
            <div class="tel" v-html="preSales"></div>
          </div>
          <div class="link">
            <div class="fz_t">售后支持</div>
            <div class="tel" v-html="afterSales"></div>
          </div>
        </div>
      </div>
      <div class="fz_fan">
        <div class="fz_li" @click="openBealter()">
          <img
            :src="require('@/assets/icon/demonstration.png')"
            alt=""
            class="icon"
          />
          <div class="text">预约演示</div>
        </div>
      </div>
      <div class="fz_fan">
        <div class="fz_li" @click="openBealter2()">
          <img
            :src="require('@/assets/icon/intelligent.png')"
            alt=""
            class="icon"
          />
          <div class="text">智能自助</div>
        </div>
      </div>
    </div>
    <div v-show="onGetop" class="fz_top" @click="goTop">
      <div class="goTop-box">
        <img :src="require('@/assets/icon/gotop.png')" alt="" class="icon" />
      </div>
    </div>
    <!-- <div class="right_video" v-if="showvideo&&this.$route.path==='/'">
      <el-button icon="el-icon-circle-close" circle size="mini" @click="showvideo=false"></el-button>
      <vue-core-video-player
        :src="'/8210151e21a8d48e91d30d311953cfc1.mp4'"
        autoplay
      />
    </div> -->
  </div>
</template>

<script>
import { getVariableInfo } from '@/api/variable'
export default {
  name: 'RightFixedget',
  data() {
    return {
      showvideo:true,
      enterIndex: null,
      fzList: [
        {
          title: '在线咨询',
          icon: require('@/assets/icon/consulting.png')
        },
        {
          title: '联系我们',
          icon: require('@/assets/icon/telephone.png')
        },
        {
          title: '预约演示',
          icon: require('@/assets/icon/demonstration.png')
        }
      ],
      preSales: '',
      afterSales: '',
      isGetop: false,
      onGetop: false
    }
  },
  mounted() {
    this.headleScroll()
    this.getVariable()
    window.addEventListener('scroll', this.headleScroll, true)
    console.log(this.$route.path,'this.$route.path');
    
  },
  methods: {
    getVariable() {
      getVariableInfo({ label: 'afterSales' }).then(res => {
        const { result } = res
        var doc = new DOMParser().parseFromString(result.content, 'text/html')
        this.afterSales = doc.documentElement.textContent.replace(
          /&nbsp;/g,
          ' '
        )
      })
      getVariableInfo({ label: 'preSales' }).then(res => {
        const { result } = res
        var doc = new DOMParser().parseFromString(result.content, 'text/html')
        this.preSales = doc.documentElement.textContent.replace(/&nbsp;/g, ' ')
      })
    },

    headleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      if (scrollTop > 400) {
        this.onGetop = true
      } else {
        this.onGetop = false
      }
    },
    goTop() {
      document.documentElement.scrollTop -= 50
      if (document.documentElement.scrollTop > 0) {
        var time = setTimeout(() => this.goTop(), 15)
      } else {
        clearTimeout(time)
        this.isGetop = false
      }
    },
    routerJump() {
      // this.$router.push({ path: '/mobileterminal' })
      // 打开机器人文章查询
    },
    openBealter() {
      this.$parent.openBealter()
    },
    openBealter2() {
      this.$parent.openBealter2()
    }
  }
}
</script>

<style lang="less" scoped>
.right-fixedgt {
  width: 72px;
  height: 365px;
  position: fixed;
  bottom: 150px;
  z-index: 990;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  .fixedgt {
    width: 72px;
    height: 285px;
    padding: 10px 0;
    box-sizing: border-box;
    background-color: rgba(207, 224, 252, 0.5);
    box-shadow: 0px 2px 3px 0px rgba(22, 117, 246, 0.32);
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    .fz_fan {
      position: relative;
      .fz_li {
        width: 60px;
        height: 60px;
        background-color: #fff;
        border-radius: 6px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        .icon {
          width: auto;
          height: 24px;
          display: block;
          margin-bottom: 8px;
        }
        .text {
          font-size: 11px;
          font-family: OPPOSans-R;
          color: #535353;
          line-height: 1;
        }
      }
      .hover {
        width: 210px;
        height: 163px;
        padding: 14px 24px;
        box-sizing: border-box;
        position: absolute;
        top: 11px;
        right: 100%;
        margin-right: 22px;
        background-color: #fff;
        border-radius: 5px;
        box-shadow: 0px 2px 8px 0px rgba(185, 188, 193, 0.32);
        visibility: hidden;
        opacity: 0;
        transition: all 0.4s;
        .link {
          padding: 12px 0;
          .fz_t {
            font-size: 14px;
            font-family: OPPOSans-R;
            line-height: 1;
            color: #535353;
            margin-bottom: 10px;
          }
          .tel {
            font-size: 16px;
            font-family: OPPOSans-B;
            color: #3577ea;
          }
        }
        &::after {
          content: '';
          display: block;
          position: absolute;
          top: 10px;
          right: -8px;
          width: 0;
          height: 0;
          border-left: 8px solid #fff;
          border-top: 8px solid transparent;
          border-bottom: 8px solid transparent;
        }
      }
      &:nth-child(2):hover {
        .hover {
          visibility: visible;
          opacity: 1;
        }
      }
    }
  }
  .fz_top {
    width: 72px;
    height: 72px;
    background-color: rgb(207, 224, 252, 0.5);
    box-shadow: 0px 2px 3px 0px rgba(22, 117, 246, 0.32);
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    .goTop-box {
      width: 60px;
      height: 60px;
      background-color: #fff;
      border-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      .icon {
        width: 36px;
        height: 36px;
        display: block;
      }
    }
  }
  .right_video {
    margin-right: 300px;
    width: 360px;
    position: relative;
    .el-button{
      position: absolute;
      left: -30px;
      top:0;
    }
  }
}
</style>
